import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Input, Col, Select, Modal, InputNumber} from 'antd'
import FormModal from './FormModal'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import UPM from '../../../constants/urlPermissionMappings'
import {PlusOutlined, SearchOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'

@inject('userManagementStore', 'roleManagementStore')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: false,
    countdown: 0,
    passwordModalVisible: false,
  }
  formRef = React.createRef()
  passwordFormRef = React.createRef()
  timerRef = null
  _isMounted = false

  componentDidMount() {
    this._isMounted = true
    const {userManagementStore} = this.props
    userManagementStore.onSearchPassword().then(() => {
      // 异步请求完成后检查
      console.log('After onSearchPassword:', userManagementStore.passwordData)
      console.log('Type:', typeof userManagementStore.passwordData)
      if (userManagementStore.passwordData?.ttl) {
        const countdownTime = userManagementStore.passwordData?.ttl || 0
        this.setState({ countdown: countdownTime })
        this.startCountdown()
      }
    })
  }

  componentDidUpdate(prevProps) {
    const {userManagementStore} = this.props
    console.log('componentDidUpdate triggered')
    console.log('current passwordData:', userManagementStore.passwordData)
    console.log('prev passwordData:', prevProps.userManagementStore.passwordData)
    if (userManagementStore.passwordData?.ttl && !prevProps.userManagementStore.passwordData?.ttl) {
      const countdownTime = userManagementStore.passwordData?.ttl || 0
      this.setState({ countdown: countdownTime })
      this.startCountdown()
    }
  }

  componentWillUnmount() {
    this._isMounted = false
    if (this.timerRef) {
      clearInterval(this.timerRef)
    }
  }

  startCountdown = () => {
    if (this.timerRef) {
      clearInterval(this.timerRef)
    }
    
    this.timerRef = setInterval(() => {
      if (!this._isMounted) {
        clearInterval(this.timerRef)
        return
      }
      
      this.setState(prevState => {
        if (prevState.countdown < 1) {
          clearInterval(this.timerRef)
          this.props.userManagementStore.onClearPassword()
          return { countdown: 0 }
        }
        return { countdown: prevState.countdown - 1 }
      })
    }, 1000)
  }

  handleSearch = () => {
    const {userManagementStore} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      userManagementStore.onChangePageNo()
      userManagementStore.onSearchUserAction({
        roleId: fieldsValue.roleId,
        status: fieldsValue.status === 'Enable' ? true : fieldsValue.status === 'Disable' ? false : '',
        searchText: fieldsValue.searchText,
      }, 1, PAGE_SIZE_DEFAULT)
    }).catch(err => {})
  }
  handlePassword=()=> {
    this.setState({
      passwordModalVisible: true
    })
  }
  
  handlePasswordSave = () => {
    const {userManagementStore} = this.props
    this.passwordFormRef.current.validateFields().then(fieldsValue => {
      userManagementStore.onGeneratePassword({
        expireMinutes: fieldsValue.expireMinutes
      }).then(() => {
          userManagementStore.onSearchPassword().then(() => {
            const countdownTime = userManagementStore.passwordData?.ttl || 0
            this.setState({
              countdown: countdownTime,
              passwordModalVisible: false
            })
            this.startCountdown()
          })
        // 重置表单
        this.passwordFormRef.current.resetFields()
      })
    }).catch(err => {})
  }
  
  handlePasswordCancel = () => {
    this.setState({
      passwordModalVisible: false
    })
    // 重置表单
    this.passwordFormRef.current.resetFields()
  }
  handleCreate = () => {
    this.setState({
      addModalVisible: true
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }

  render() {
    const {roleManagementStore, userManagementStore, location, t} = this.props
    const {roleList} = roleManagementStore
    const {passwordData} = userManagementStore
    return (
      <div className="container">
        <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Row gutter={[10, 0]}>
            <Col span={4}>
              <Form.Item name="roleId" label={t(`userManagement.roles`)}>
                <Select placeholder={t(`general.pleaseEnter`)} allowClear>
                  {roleList?.map(item => <Select.Option key={item.name} value={item.id}>{item.name}</Select.Option>)}
                </Select>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="status" label={t(`userManagement.status`)}>
                <Select placeholder={t(`general.pleaseEnter`)} allowClear>
                  <Select.Option key="Enable" value="Enable">Enable</Select.Option>
                  <Select.Option key="Disable" value="Disable">Disable</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="searchText" label={t(`userManagement.userName`)}
                         rules={[{
                           message: `${t(`general.pleaseEnter`)} ${t(`userManagement.userName`)} ${t(`general.withoutSpecialChats`)}`,
                           pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                         }]}>
                <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>
            <Col span={12} style={{textAlign: 'right', marginTop: 30}}>
              { passwordData?.password ? <div className='expireMinutes'>
                {t(`userManagement.globalPassword`)}: <span style={{ padding: '0 20px 0 10px'}}>{passwordData?.password}</span>
                {t(`userManagement.expireMinutes`)}: <span style={{color: 'orange', fontWeight: 'bolder', padding: '0 5px 0 10px'}}>{this.state.countdown}</span>s
              </div> : <Button onClick={this.handlePassword} type='primary'>{t(`general.generatePassword`)}</Button>}

              <Button onClick={this.handleSearch} type='danger'>{t(`general.search`)}</Button>
              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
            </Col>
          </Row>
        </Form>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
        /> : null}
        
        {/* 密码生成弹窗 */}
        <Modal
          title={t(`general.generatePassword`)}
          visible={this.state.passwordModalVisible}
          onCancel={this.handlePasswordCancel}
          footer={null}
          width={400}
        >
          <Form ref={this.passwordFormRef} layout="vertical">
            <Form.Item
              name="expireMinutes"
              label={t(`userManagement.expireMinutes`) + '（' + t(`general.minute`) + '）'}
              rules={[
                {
                  required: true,
                  message: t(`general.pleaseEnter`)
                },
                {
                  type: 'number',
                  min: 1,
                  message: t(`general.pleaseEnterPositiveInteger`)
                }
              ]}
            >
              <InputNumber
                min={1}
                style={{ width: '100%' }}
                placeholder={t(`general.pleaseEnter`)}
              />
            </Form.Item>
            <div style={{ textAlign: 'right', marginTop: 20 }}>
              <Button onClick={this.handlePasswordCancel} style={{ marginRight: 8 }}>
                {t(`general.cancel`)}
              </Button>
              <Button type="primary" onClick={this.handlePasswordSave}>
                {t(`general.generatePassword`)}
              </Button>
            </div>
          </Form>
        </Modal>
      </div>
    )
  }
}

export default withTranslation()(SearchForm)
